module.exports = __webpack_public_path__ + "static/media/31JFA4.ae147b8c.jpg";